module.exports = __webpack_public_path__ + "img/6.cecc0aac.png";